module.exports = __webpack_public_path__ + "images/favicon-286a4aab73387e1270f3ddb6e8101652.ico";